import { useState } from "react";
import { ButtonSubmit } from "../ButtonSubmit";
import InputGlobal from "../InputGlobal";
import {
  COOKIE_NAME,
  COOKIE_QUERY_NAME,
  deleteCookie,
  gtmRegistration,
  validatePassword,
  validateName,
  validateEmail,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  prepareRegistrationData,
  REGISTRATION_CONFIRMED,
  simplyClick,
} from "../../helpers";
import "./SecondStep.scss";
import { apiRegistration } from "../../services/api";
import Eye from "../../images/eye.svg";
import EyeOff from "../../images/eye-off.svg";

export const SecondStep = ({ data, setData, nextStep }) => {
  const [checkBox, setCheckBox] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [termsError, setTermsError] = useState(null);
  const [errorName, setErrorName] = useState(null);
  const [errorEmail, setErrorEmail] = useState(null);
  const [errorPassword, setErrorPassword] = useState(null);
  const [loader, setLoader] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const [responseEmailError, setResponseEmailError] = useState(null);
  const [value, setValue] = useState("");

  const domains = [
    "@gmail.com",
    "@yahoo.com",
    "@hotmail.com",
    "@aol.com",
    "@outlook.com",
    "@comcast.net",
    "@live.com",
    "@mail.com",
    "@msn.com",
    "@att.net",
    "@icloud.com",
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    const { error, status } = validateName(data.first_name);
    if (!status) {
      setErrorName(error);
    }

    const resultEmail = validateEmail(value);
    if (!resultEmail.status) {
      setErrorEmail(resultEmail.error);
    }

    setResponseError(null);
    const resultPassword = validatePassword(data.password);
    if (!resultPassword.status) {
      setErrorPassword(resultPassword.error);
    }
    if (!checkBox) {
      setTermsError(
        "Please accept our Terms of Use, Privacy Policy, Cookie Policy, Billing & Refund Policy, Risks notice, Disclosures & Disclaimers",
      );
    }
    if (status && resultEmail.status && resultPassword.status && checkBox) {
      apiRegistration(prepareRegistrationData(data), responseCb);
      setLoader(true);
    }
  };

  const responseCb = (response) => {
    setLoader(false);
    if (response.status === 200) {
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);
        gtmRegistration(data.data);

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed == REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }

      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);
      let errorText = "";
      data.errors.map((error) => {
        if (error.name === "email") {
          setResponseEmailError(error.message);
        } else if (error.name !== "email") {
          errorText += error > 0 ? " " + error.message : error.message;
        }
      });

      if (errorText !== "") {
        setResponseError(errorText);
      }
      return;
    } else if (response.status === 403) {
      window.location.href = "/moderation/";
      return;
    }

    setResponseError(
      "Can't register your profile now. Please try again later.",
    );
  };

  const handleCheckBox = (e) => {
    setTermsError(false);
    setCheckBox(!checkBox);
    simplyClick("cl_lnd_qm1_step1_policy", null, false);
  };

  const handleAddPassword = (e) => {
    setErrorPassword(null);
    setData({ ...data, password: e.target.value });
  };

  const handleAddName = (e) => {
    setErrorName(null);
    setData({ ...data, first_name: e.target.value });
  };

  const handleAddEmail = (e) => {
    setEmailValue(e.target.value);
    setData({ ...data, email: e.target.value });
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setValue(value);
  };

  const setFullEmail = (fullEmail) => {
    setErrorEmail(null);
    setValue(fullEmail);
    setData({ ...data, email: fullEmail });
  };

  const toggleBtn = (e) => {
    e.preventDefault();
    setPasswordShow(!passwordShow);
  };

  return (
    <>
      <main className="main__second">
        {loader && (
          <div className="spin-loader">
            <span>Loading...</span>
          </div>
        )}
        <div className="main__second-wrapper">
          <form className="second__step-form" onSubmit={handleSubmit}>
            <span onClick={() => nextStep()} className="close">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00116 8.00001L14.9913 14.9901M1.01099 14.9901L8.00116 8.00001L1.01099 14.9901ZM14.9913 1.00983L8.00116 8.00001L14.9913 1.00983ZM8.00116 8.00001L1.01099 1.00983L8.00116 8.00001Z"
                  stroke="#7D838D"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <div className="second__step-form-box">
              <h2 className="second__form-title">Join free now</h2>
              <div className="inputs__wrapper">
                <div className="name__wrapper">
                  <span className="label">First name </span>
                  <InputGlobal
                    className={"input__global"}
                    onChange={(e) => handleAddName(e)}
                    name={"name"}
                    placeholder={"Type your name"}
                    type={"text"}
                  />
                </div>
                {errorName && <p className="error-text">{errorName}</p>}
                <div className="email__wrapper">
                  <span className="label">Email</span>
                  <InputGlobal
                    className={"input__global"}
                    onChange={(e) => handleAddEmail(e)}
                    name={"email"}
                    placeholder={"Type your email"}
                    type={"text"}
                    value={value}
                  />
                  {value.length > 0 && !value.includes("@") && (
                    <div className="autocomplete__box">
                      <ul className="autocomplete__box-list">
                        {domains.map((domain, index) => (
                          <li
                            onClick={() => setFullEmail(value + domain)}
                            className="autocomplete__box-list-item"
                            key={index}
                          >
                            {value}
                            {domain}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                {errorEmail && <p className="error-text">{errorEmail}</p>}
                {responseEmailError && (
                  <p className="error-text">{responseEmailError}</p>
                )}
                <div className="password__wrapper">
                  <span className="label">Password</span>
                  <InputGlobal
                    className={"input__global"}
                    onChange={(e) => handleAddPassword(e)}
                    name={"password"}
                    placeholder={"Create your password"}
                    type={passwordShow ? "text" : "password"}
                  />
                  <button onClick={toggleBtn} className="logo__eye">
                    {passwordShow ? (
                      <img src={Eye} alt="icon" />
                    ) : (
                      <img src={EyeOff} alt="icon" />
                    )}
                  </button>
                </div>
                {errorPassword && <p className="error-text">{errorPassword}</p>}
                {responseError && <p className="error-text">{responseError}</p>}
                <span className="border"></span>
                <div
                  className={"terms__wrapper" + (termsError ? " error" : "")}
                >
                  <input
                    checked={checkBox}
                    onChange={(e) => handleCheckBox(e)}
                    type="checkbox"
                    id="remember_me"
                    className="checkBox"
                    name="remember"
                    value="1"
                  />
                  <label htmlFor="remember_me">
                    <span> I have read, understand and agree to&nbsp;</span>
                    <span>
                      <a href="/terms-of-use/" target="_blank">
                        Terms of Use,&nbsp;
                      </a>
                      <a href="/privacy-policy/" target="_blank">
                        Privacy Policy,&nbsp;
                      </a>
                      <a href="/cookie-policy/" target="_blank">
                        Cookie policy,&nbsp;
                      </a>
                      <a href="/billing-policy/" target="_blank">
                        Billing &&nbsp;
                      </a>
                      <a href="/refund-policy/" target="_blank">
                        Refund Policy,&nbsp;
                      </a>
                      <a href="/risks-notice/" target="_blank">
                        Risks notice,&nbsp;
                      </a>
                      <a href="/disclosures-disclaimers/" target="_blank">
                        Disclosures & Disclaimers
                      </a>
                    </span>
                  </label>
                </div>
                {termsError && <p className="error-text terms">{termsError}</p>}

                <ButtonSubmit
                  className={"button__global button__second"}
                  text={"Join now"}
                  onClick={() =>
                    simplyClick("cl_lnd_qm1_step1_join", null, false)
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </main>
    </>
  );
};
